var map = {
	"./australia_a_league/cooperator.png": "byKg",
	"./la_liga/cooperator.png": "HMtQ",
	"./premier_league/cooperator.png": "9RVp",
	"./serie_a/cooperator.png": "HjEM",
	"./wolves/cooperator.png": "BYgh"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "B+nM";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\/cooperator\.png$
// module id = B+nM
// module chunks = 1